import { render } from "./ReleaseDetails.vue?vue&type=template&id=55692a64&scoped=true"
import script from "./ReleaseDetails.vue?vue&type=script&lang=js"
export * from "./ReleaseDetails.vue?vue&type=script&lang=js"

import "./ReleaseDetails.vue?vue&type=style&index=0&id=55692a64&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55692a64"]])

export default __exports__